export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14493.44ffe496.jpg";